export default {
  props: ["selected-merchant-id", 'merchants-list', 'selected-service-id', 'selected-agency-id', 'selected-agent-id', 'services-list', 'agencies-list', 'agents-list', 'agent-margin', 'commission'],
  data() {
    return {
      merchant: {},
      service: {},
      agency: {},
      agent: {},
      agency_id: null,
      merchant_id: null,
      selectedAgency: {},
      agent_margin: null,
      agent_commission: null,
    };
  },
  mounted() {
    if(this.agentMargin){
      this.agent_margin = this.agentMargin;
    }
    if (this.commission) {
      this.agent_commission = this.commission;
    }
    if (this.selectedMerchantId) {
      this.merchant = this.merchantsList.find((m) => {
        return m.value == this.selectedMerchantId
      }) || {}
    }
    if (this.selectedServiceId) {
      this.service = this.servicesList.find((s) => {
        return s.value == this.selectedServiceId
      }) || {}
    }
    if (this.selectedAgencyId) {
      this.agency = this.agenciesList.find((s) => {
        return s.value == this.selectedAgencyId
      }) || {}
    }

    if (this.selectedAgentId) {
      this.agent = this.agentsList.find((s) => {
        return s.value == this.selectedAgentId
      }) || {}
    }
  },
  methods: {
    setSelected: function (v) {
      this.agency_id = v.agency;
      this.merchant_id = v.merchant;
      this.$emit("mainmerchant", this.merchant_id);
      this.$emit("mainagency", this.agency_id);
    },
    resetSelectedAgency(v) {
      this.agency = v;
    },
    setMargin(value){
      this.$emit("margin", this.agent_margin);
    },
    setCommissionType(value) {
      this.$emit("commission", this.agent_commission);
    }
  }
}